import React from "react";
import { List, Datagrid, TextField, DateField, EmailField } from "react-admin";

export const ServiceMailLogList = () => (
  <List>
    <Datagrid>
      <TextField source="service_mail" />
      <EmailField source="recipient_email" />
      <TextField source="user_email" />
      <TextField source="status" />
      <TextField source="error" />
      <DateField source="sent_at" showTime />
      <DateField source="created_at" showTime />
    </Datagrid>
  </List>
);
